import * as React from 'react';

export const AlertContent = (props) => {
    return (
        <div>
            { props.alert.message }
        </div>
    );
};
